export default __webpack_public_path__ + "static/media/GenericDB.d5da17f0.svg";